'use client'

import { Box, Heading, Text, HStack, VStack } from '@chakra-ui/react'
import { FC } from 'react'
import { ContentContainer } from 'ui'
import { GrandButton } from '../ui/GrandButton'

export type CTASectionProps = {
  title: string
  description: string
  primaryButtonText?: string
  primaryButtonHref?: string
  secondaryButtonText?: string
  secondaryButtonHref?: string
  variant?: 'teal' | 'dark'
}

export const CTASection: FC<CTASectionProps> = ({
  title,
  description,
  primaryButtonText = "Let's figure it out together",
  primaryButtonHref = '/signup',
  secondaryButtonText,
  secondaryButtonHref,
  variant = 'teal'
}) => {
  const bgColor = variant === 'teal' ? 'background.accent' : 'background.dark'

  return (
    <Box
      as="section"
      w="100%"
      py={{ base: 16, md: 32 }}
      bg={bgColor}
      color="white"
      textAlign="center"
    >
      <ContentContainer maxW="600px" justify="center">
        <VStack spacing={6} w="100%">
          <Heading
            as="h2"
            fontFamily="display"
            fontSize={{ base: '1.8rem', md: '2.4rem' }}
            fontWeight={500}
            lineHeight={1.2}
            color="white"
          >
            {title}
          </Heading>

          <Text fontSize="1.1rem" color="whiteAlpha.700" maxW="500px">
            {description}
          </Text>

          <HStack spacing={4} pt={4} flexWrap="wrap" justify="center">
            <GrandButton href={primaryButtonHref} variant="ctaPrimary" showArrow>
              {primaryButtonText}
            </GrandButton>

            {secondaryButtonText && secondaryButtonHref && (
              <GrandButton href={secondaryButtonHref} variant="ctaSecondary">
                {secondaryButtonText}
              </GrandButton>
            )}
          </HStack>
        </VStack>
      </ContentContainer>
    </Box>
  )
}
